export default __webpack_public_path__ + "static/medical_gas_w.5e647df1ed69503f4b920a38ada5b21e.svg";